import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListSalesOrderTotalsInput } from "@nexxt/contracts/sales";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the orders by season and status (spec v0.3 §9, ADR-261): one read per page. Under the key of the
// sales orders, so every write on an order reads them again.

const totals = api.sales["sales-order-totals"];

type TotalsPage = InferResponseType<typeof totals.$get, 200>;
export type SalesOrderTotal = TotalsPage["items"][number];

/** The filters of the input (`listSalesOrderTotalsInput`), without the paging the query adds. */
export type SalesOrderTotalFilters = Pick<ListSalesOrderTotalsInput, "season" | "brand" | "status">;

const PAGE_SIZE = 100;

const keys = {
  all: ["sales-orders", "totals"] as const,
};

export const salesOrderTotalQueries = {
  ...keys,

  /** The latest season first, then by brand and customer. */
  list: (filters: SalesOrderTotalFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          totals.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
